export default __webpack_public_path__ + "static/media/avatar.b76359b7.jpg";